// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wB zQ","ribbon":"wC zZ","title":"wD zS","year":"wE zT","genres":"wF zY","duration":"wG","buttonWrapper":"wH zU","button":"wI zV","price":"wJ","upperParts":"wK"};